var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.handleClick}},[_c('PinnedBtn',{attrs:{"text":_vm.text,"buttonImage":_vm.buttonImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }